export const parseGradientColor = (color: string) => {
  const matches = color.match(/\((.*)?\)/);

  if (!matches) {
    throw new Error('Invalid gradient');
  }

  const [angle, ...pairs] = matches[1].split(/,\s*/);

  return {
    angle: Number(angle.split('deg')[0]),
    ...pairs.reduce<{ colors: string[]; locations: number[] }>(
      (accumulator, pair) => {
        const [color, percent] = pair.split(/\s+/);

        accumulator.colors.push(color);

        if (percent) {
          const location = Number(percent.split('%')[0]) / 100;

          accumulator.locations.push(Math.max(0, Math.min(location, 1)));
        }

        return accumulator;
      },
      {
        colors: [],
        locations: [],
      },
    ),
  };
};

export const getGradientDirection = (isHorizontal?: boolean) =>
  isHorizontal
    ? {
        start: { x: 0, y: 0 },
        end: { x: 1, y: 0 },
      }
    : {
        start: { x: 0, y: 0 },
        end: { x: 0, y: 1 },
      };
